import { render, staticRenderFns } from "./custom_searchBox.vue?vue&type=template&id=8c10e4bc&scoped=true"
import script from "./custom_searchBox.vue?vue&type=script&lang=js"
export * from "./custom_searchBox.vue?vue&type=script&lang=js"
import style0 from "./custom_searchBox.vue?vue&type=style&index=0&id=8c10e4bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c10e4bc",
  null
  
)

export default component.exports